import { type Item, type ItemAvailabilityStatus } from '@cheqroom/api';

const isUnavailable = (availabilityStatus: ItemAvailabilityStatus) =>
	availabilityStatus !== 'available' && availabilityStatus !== 'unavailable_status';

type IsItemUnavailableItem = Pick<Item, 'canReserve' | 'canOrder' | 'status' | 'kind'> & {
	kit?: Pick<NonNullable<Item['kit']>, '_id'>;
};

export const isItemUnavailable = (
	item: IsItemUnavailableItem,
	canUseOrders: boolean,
	canUseReservations: boolean
): boolean => {
	const { canReserve, canOrder, status, kind, kit } = item;

	if (status !== 'available') {
		return false;
	}

	if (!canUseOrders && !canUseReservations) {
		return false;
	}

	if (canUseReservations && !isUnavailable(canReserve)) {
		return false;
	}

	if (canUseOrders && !isUnavailable(canOrder)) {
		return false;
	}

	// For a bulk item, canReserve and canOrder are for the loose bulk item, not the kitted bulk item
	if (
		kind === 'bulk' &&
		kit &&
		(!canUseReservations || canReserve === 'unavailable_other') &&
		(!canUseOrders || canOrder === 'unavailable_other')
	) {
		return false;
	}

	return true;
};
